(function() {
'use strict';

angular
    .module('searchUnit')
    .directive('roomSearchUnit', roomSearchUnit);

function roomSearchUnit(
        $routeParams,
        broker,
        searchUnitService,
        sharedSearchUnitService,
        occupancyService,
        bd4travel,
        unifiedSearchService,
        scrollService) {
    // Configuration part, mandatory in every searchunit directive with delayed linker
    sharedSearchUnitService.addDelayedLinker(_delayedLinker, 'roomSearchUnit');

    return {
        restrict: 'E',
        replace: true,
        scope: {
            landing: '@'
        },
        templateUrl: 'partials/searchunit/room',
        controller: 'SharedSearchUnit',
        link(scope, el, attr, controller) {
            return sharedSearchUnitService.initializeArea(scope, el, attr, controller, 'roomSearchUnit');
        }
    };

    function _delayedLinker(scope, $element, attr, ssu) {
        let notModel = {};
        unifiedSearchService
            .prepopulateModel(notModel, {})
            .then(m => bd4travel.trackInitialParameters(m, 'productDetails,hotel'));

        const currentArea = sharedSearchUnitService.getAreaInfo();

        scope.dateRangeMetadata = {
            minStartDate: searchUnitService.getMinStartDate(currentArea.name),
            enabledStartDates: {},
            durations: {},
            showDatePicker: false,
            selectDateRange: () => {
                searchUnitService.startDate(currentArea.mode, scope.startDate);
                searchUnitService.endDate(currentArea.mode, scope.endDate);
                scope.dateRangeMetadata.showDatePicker = false;
            }
        };

        scope.occupancyMetadata = searchUnitService.getOccupancyConfig(currentArea.name);
        scope.occupancyMetadata.showOccupancyPicker = false;
        scope.$watchCollection('occupancy', val => {
            if (val && val[0]) {
                scope.occupancyMetadata.occupancyCaption = occupancyService.getOccupancyString(val);
                occupancyService.setOccupancy(val);
            }
        });

        _restoreSearchCriteria();

        scope.updateCurrency = updateCurrency;
        scope.currencyOptions = searchUnitService.getCurrencyOptions();
        scope.toggleOptions = () => { scope.expandedOptions = !scope.expandedOptions; };
        scope.searchRooms = searchRooms;
        scope.searching = false;

        function searchRooms() {
            scope.searching = true;
            broker.publish('roomSearchStarted');
            scope.$emit('flash:error', null);
            if (scope.landing) { ssu.lockScreen('SEARCHINGFORROOMSPROMPT'); }
            scrollService.setScrollTarget('#roomsPanel');
            sharedSearchUnitService.search(null, _showRoomErrors, {
                roomSearch: true,
                estabId: $routeParams.estabId
            });
        }

        function _showRoomErrors(errors) {
            scope.searching = false;
            broker.publish('roomSearchEnded');
            scope.$emit('flash:error', errors);
            ssu.unlockScreen();
        }

        function _restoreSearchCriteria() {
            scope.startDate = searchUnitService.startDate(currentArea.mode);
            scope.endDate = searchUnitService.endDate(currentArea.mode);
            scope.occupancy = occupancyService.getOccupancy();
            scope.currency = searchUnitService.getCurrency();
        }

        function updateCurrency() {
            searchUnitService.setCurrency(scope.currency);
        }
    }
}
})();
